export const shortenShopifyId = (shopifyId: string) => {
  return (shopifyId ?? '').split('/').pop() ?? shopifyId
}

export const shortenShopifyIdToNumeric = (shopifyId: string | undefined | null) => {
  if (!shopifyId || shopifyId.length === 0) return null
  const result = parseInt(shortenShopifyId(shopifyId), 10)
  return isNaN(result) ? null : result
}
